import { get } from "lodash";
import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Form } from "semantic-ui-react";

import FormikAPIErrorMessage from "../formik/FormikAPIErrorMessage.jsx";

class WeekDayMultiSelect extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    field: PropTypes.object.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    apiErrors: PropTypes.object
  };

  static defaultProps = {
    readOnly: false,
    disabled: false
  };

  static DAY_MAP = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
  ];

  // -- DATA MANAGEMENT -- //

  getWeekDays(start, end) {
    // gives us the order days of the week should be displayed but not their value :/
    const localeDays = moment.weekdays(true);

    const values = [];
    let value = start.clone();

    while (value.unix() < end.unix()) {
      const text = value.format("dddd");
      const index = localeDays.findIndex(item => item === text);

      values[index] = {
        text: text,
        value: value.day()
      };

      value.add(1, "d");
    }

    return values;
  }

  getAvailableWeekDays = () => {
    const from = get(this.props, "form.values.from", null);
    const to = get(this.props, "form.values.to", null);

    let diff = 7;

    if (from && to) {
      const fromMoment = moment(from);
      const toMoment = moment(to);
      diff = toMoment.diff(fromMoment, "d");
    }

    if (diff < 6) {
      return this.getWeekDays(fromMoment, toMoment);
    } else {
      // use arbitraily chosen 7 day range to retrieve the value for each day by name
      return this.getWeekDays(moment("2018-01-01"), moment("2018-01-08"));
    }
  };

  buildSelectedArrayFromProps(data) {
    if (!data) return [];

    return WeekDayMultiSelect.DAY_MAP.map((item, index) => {
      return data[item] === true ? index : null;
    }).filter(item => item !== null);
  }

  buildSelectedObjectFromArray(data) {
    if (!data) return {};

    // build week day object, all days are set to make updates easier
    return WeekDayMultiSelect.DAY_MAP.reduce((obj, value, index) => {
      obj[value] = data.findIndex(item => item === index) > -1 ? true : false;
      return obj;
    }, {});
  }

  // -- HANDLERS -- //

  onChange = (evt, item) => {
    const {
      form: { setFieldValue }
    } = this.props;

    const selectedObj = this.buildSelectedObjectFromArray(item.value.slice());

    Object.keys(selectedObj).forEach((key, index) => {
      setFieldValue(key, selectedObj[key]);
    });
  };

  // -- RENDER -- //

  render() {
    const {
      form: { values },
      field: { name },
      readOnly,
      disabled,
      label,
      placeholder,
      required = false,
      apiErrors
    } = this.props;

    const selected = this.buildSelectedArrayFromProps(values);
    const availableWeekdays = this.getAvailableWeekDays();

    if (!readOnly) {
      return (
        <Form.Field required={required}>
          {label && <label>{label || null}</label>}
          <Form.Dropdown
            readOnly={readOnly}
            disabled={disabled}
            selection
            multiple
            options={availableWeekdays}
            placeholder={placeholder}
            value={selected}
            onChange={this.onChange}
          />
          <FormikAPIErrorMessage name={name} apiErrors={apiErrors} />
        </Form.Field>
      );
    }

    const selectedDays = selected
      .map(item => availableWeekdays[item].text)
      .join(", ");

    return (
      <Form.Field required={required}>
        {label && <label>{label || null}</label>}
        <p>{selectedDays}</p>
      </Form.Field>
    );
  }
}

export default WeekDayMultiSelect;
